import React from "react";
import { AlertCircle, Filter as FilterIcon, Settings } from "lucide-react";

import { Filter } from "../../../components/ui/Filter";
import { CAMPO } from "../../../components/ui/Filter/sizes";
import { Input } from "../../../components/ui/Form/Input";
import { Select } from "../../../components/ui/Form/Select";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { CRM_PET_RULES } from "../../../services/formatResponses/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";

export function CrmPetFilter() {
  const CCrmPet = CrmPetController();
  const filter = useCrmPet((st) => st.data.filter);
  const isLoading = useCrmPet((st) => st.data.isLoading);
  const error = useCrmPet((st) => st.data.error);

  return (
    <>
      <Filter.Root onSubmit={CCrmPet.filterPets}>
        <Filter.Container>
          <Input.Root
            label="Buscar"
            style={CAMPO.busca}
            value={filter.search}
            onChange={(search) => CCrmPet.setFilter({ search })}
          />
          {filter.rule === CRM_PET_RULES.ABSENT && (
            <Select.Root
              label="Ausência mínima"
              value={filter.minDays}
              style={CAMPO.medio}
              onChange={(minDays) => CCrmPet.setFilter({ minDays })}
            >
              <Select.Option value="7">7d</Select.Option>
              <Select.Option value="15">15d</Select.Option>
              <Select.Option value="30">30d</Select.Option>
              <Select.Option value="45">45d</Select.Option>
              <Select.Option value="60">60d</Select.Option>
              <Select.Option value="90">90d</Select.Option>
            </Select.Root>
          )}
          {/*
            * Avulsos (POTENTIAL_SUBSCRIBER) e, por definicao, quem NAO assina:
            * o filtro ali so teria uma resposta possivel e confundiria.
            */}
          {filter.rule !== CRM_PET_RULES.POTENTIAL_SUBSCRIBER && (
            <Select.Root
              label="Assinante"
              value={filter.subscriber}
              style={CAMPO.medio}
              onChange={(subscriber) => CCrmPet.setFilter({ subscriber })}
            >
              <Select.Option value="ALL">Todos</Select.Option>
              <Select.Option value="YES">Sim</Select.Option>
              <Select.Option value="NO">Não</Select.Option>
            </Select.Root>
          )}
          <Select.Root
            label="Contato"
            value={filter.contact}
            style={CAMPO.medio}
            onChange={(contact) => CCrmPet.setFilter({ contact })}
          >
            <Select.Option value="ALL">Todos</Select.Option>
            <Select.Option value="CONTACTED">Contatados</Select.Option>
            <Select.Option value="PENDING">Pendentes</Select.Option>
          </Select.Root>
        </Filter.Container>
        <Filter.Actions>
          <Filter.Action isLoading={isLoading}>
            <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
            Filtrar
          </Filter.Action>
          <Filter.Action outline type="button" onClick={CCrmPet.clearFilter}>
            Limpar
          </Filter.Action>
          <Filter.Action type="button" onClick={CCrmPet.openConfig} title="Configurações">
            <Filter.ActionIcon icon={Settings} />
          </Filter.Action>
        </Filter.Actions>
      </Filter.Root>

      {error && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#fef2f2", border: "1px solid #fca5a5", color: "#dc2626", borderRadius: 10, padding: "10px 16px", fontSize: 13 }}>
          <AlertCircle size={15} style={{ flexShrink: 0 }} />
          <span>{error}</span>
          <button onClick={CCrmPet.findPets} style={{ marginLeft: "auto", background: "none", border: "none", cursor: "pointer", color: "#dc2626", textDecoration: "underline", fontSize: 12 }}>
            Tentar novamente
          </button>
        </div>
      )}
    </>
  );
}
